import { TabView, TabPanel } from "primereact/tabview";
import localeText from "../../../../locale";
import ListPhysicalStores from "./ListPhysicalStores";
import ListPendingStores from "./ListPendingStores";

const PhysicalStores = () => {
  return (
    <div className="card border-1 border-300">
      <h3 className="my-4">{localeText("physicalStores")}</h3>

      <TabView>
        <TabPanel header={localeText("physicalStoresPending")}>
          <ListPendingStores />
        </TabPanel>
        <TabPanel header={localeText("physicalStoresApproved")}>
          <ListPhysicalStores />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default PhysicalStores;
